import { setTutorialsHandlers } from "./setTutorials";
import { createReducer } from "../../../../core/reduxUtils";

const initialState = {
  tutorialsList: [],
  totalTutorials: 0,
  tutorial: {},
  tutorialByUser: [],
  addTutorialLoading: false,
  tutorialListLoading: false,
  error: "4444",
};

const handlers = {
  ...setTutorialsHandlers,
};

const tutorialReducer = createReducer(initialState, handlers);

export default tutorialReducer;
